module.exports = __webpack_public_path__ + "img/tk.e7397922.svg";